import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface ExcludedUser {
  _id: string;
  employee_id: string;
  employee_name: string;
}

@Component({
  selector: 'app-excluded-rfr-users-listing',
  templateUrl: './excluded-rfr-users-listing.component.html',
  styleUrls: ['./excluded-rfr-users-listing.component.css']
})
export class ExcludedRfrUsersListingComponent implements OnInit {
  excludedList: ExcludedUser[] = [];
  filteredList: ExcludedUser[] = [];

  isLoading = false;
  loadError: string | null = null;

  searchText = '';

  constructor(
    private apiService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadExcludedUsers();
  }

  goBack(): void {
    this.router.navigate(['admin/hrm-menu/vacation-monitoring'], {
      state: { returnToSettings: true }
    });
  }

  loadExcludedUsers(): void {
    this.isLoading = true;
    this.loadError = null;

    this.apiService.getExcludedRfrEmployees().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        const list = res?.data?.employees || res?.data || [];
        if (Array.isArray(list)) {
          this.excludedList = list;
          this.applyFilters();
        } else {
          this.excludedList = [];
          this.filteredList = [];
          this.loadError = 'Unable to load excluded users.';
        }
      },
      error: (err: any) => {
        console.error('Error loading excluded RFR users:', err);
        this.isLoading = false;
        this.excludedList = [];
        this.filteredList = [];
        this.loadError = 'Failed to load data from server.';
      }
    });
  }

  reload(): void {
    this.loadExcludedUsers();
  }

  applyFilters(): void {
    const term = this.searchText.trim().toLowerCase();
    if (!term) {
      this.filteredList = [...this.excludedList];
      return;
    }
    this.filteredList = this.excludedList.filter((u) =>
      (u.employee_name || '').toLowerCase().includes(term)
    );
  }

  editList(): void {
    this.router.navigate(['/admin/excluded-rfr-users-edit']);
  }

  trackByUser(index: number, item: ExcludedUser): string {
    return item._id || index.toString();
  }
}